/* eslint-disable @typescript-eslint/indent */
/* eslint-disable @next/next/no-img-element */
import { randomId } from '@pwskills/rachnaui/utils';
import React, { useEffect, useRef, useState } from 'react';
import GlimpsesCard from './glimpsesCard';

const GlimpsesAnimFromDesktopAndTab = ({ Glimpses }: { Glimpses: any }) => {
  const targetRefs = useRef<(HTMLDivElement | null)[]>([]);
  const parentDiv = useRef<HTMLDivElement | null>(null);
  const sectionRef = useRef<HTMLDivElement | null>(null);
  const [arrowPosition, setArrowPosition] = useState({
    top: 0,
    left: 0,
  });
  const [currentTarget, setCurrentTarget] = useState(-1);
  const [hasPlayed, setHasPlayed] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const timerRef = useRef<any>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && parentDiv?.current) {
          // clearTimeout(timerRef.current);
          if (parentDiv?.current) {
            const parentDivCurrent = parentDiv?.current;
            const offsetWidth = parentDivCurrent?.offsetWidth ?? 0;

            setArrowPosition({
              top: 0,
              left: (offsetWidth / 100) * 20, // Position at first dot initially
            });
          }
          setCurrentTarget(0);
        }
      },
      { threshold: 0.5 } // Adjust threshold as needed
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [hasPlayed]);

  // Move arrow to the given target index
  const moveArrow = (targetIndex: number) => {
    setHasPlayed(false);
    if (targetRefs.current[targetIndex]) {
      const parentDivCurrent = parentDiv?.current;
      const offsetWidth = parentDivCurrent?.offsetWidth ?? 0;
      const left = (offsetWidth / 100) * 20 * (targetIndex + 1);
      setArrowPosition({
        top: 0,
        left,
      });
    }
  };

  useEffect(() => {
    if (currentTarget === -1) return; // No need to run if currentTarget is not set

    moveArrow(currentTarget);

    if (currentTarget === 0) {
      setIsPlaying(true);

      setCurrentTarget(currentTarget + 1);
    }

    // Move to the next target after 2 seconds
    else
      timerRef.current = setTimeout(() => {
        if (currentTarget < targetRefs.current.length - 1 || currentTarget === 3) {
          setCurrentTarget(currentTarget + 1);
          setIsPlaying(false);
          setTimeout(() => {
            setIsPlaying(true);
          }, 500);

          if (currentTarget === 4) {
            setCurrentTarget(-1);
            // console.log('hasPlayed--', hasPlayed);
            setHasPlayed(true);
          }
        }
      }, 2000);

    // eslint-disable-next-line consistent-return
    return () => clearTimeout(timerRef.current);
  }, [currentTarget]);

  useEffect(() => {
    if (parentDiv?.current) {
      const parentDivCurrent = parentDiv?.current;
      const offsetWidth = parentDivCurrent?.offsetWidth ?? 0;

      setArrowPosition({
        top: 0,
        left: (offsetWidth / 100) * 20, // Position at first dot initially
      });
    }
  }, [parentDiv?.current]);

  return (
    <div ref={sectionRef}>
      <div
        className="relative flex flex-col items-center justify-center h-[502px] large:h-[542px] "
        ref={parentDiv}
      >
        {/* Horizontal dotted line */}
        <div className="relative w-full">
          <div className="absolute inset-x-0 flex justify-between z-[1]">
            {[...Array(4)].map((_, index) => (
              <div
                key={randomId()}
                className={`rounded-full translate-y-[-50%] `}
                style={{ position: 'absolute', left: `${(index + 1) * 20}%`, top: '50%' }}
                ref={(el) => {
                  targetRefs.current[index] = el;
                }}
              >
                {index === currentTarget - 1 && !isPlaying ? (
                  <div className="image-containers">
                    <img
                      src="/images/masterclassDescription/target.svg"
                      className="images image1"
                      alt="1"
                    />
                    <img
                      src="/images/masterclassDescription/check.svg "
                      className="images image2"
                      alt="1"
                    />
                  </div>
                ) : currentTarget > index ? (
                  <img
                    src="/images/masterclassDescription/check.svg "
                    alt="check"
                    className={`!min-w-6 !min-h-6 ${
                      index + 1 === currentTarget
                        ? 'transition-opacity duration-2000 ease-out opacity-100'
                        : 'opacity-100'
                    }`}
                  />
                ) : (
                  <img
                    src="/images/masterclassDescription/target.svg"
                    alt="target"
                    className="!min-w-6 !min-h-6 transition-opacity"
                  />
                )}
                <div
                  className={`absolute ${index % 2 === 0 ? 'bottom-[100px]' : 'top-[100px]'} `}
                  style={{
                    left: '50%',
                    transform: 'translate(-50%,0px)',
                  }}
                >
                  {Glimpses && (
                    <GlimpsesCard
                      glimpsesInfo={Glimpses[index]}
                      //   cardStyle={`${
                      //     index === currentTarget
                      //       ? 'glimpsesCardAnim'
                      //       : currentTarget > index
                      //       ? ' bg-blend-normal '
                      //       : 'bg-blend-luminosity opacity-80 '
                      //   }`}
                      cardIndex={index}
                      currentTarget={currentTarget}
                      isMobile={false}
                      isPlaying={isPlaying}
                    />
                  )}
                </div>
              </div>
            ))}
            {parentDiv.current && (
              <div
                className="arrow bg-white rounded-full"
                style={{
                  top: `${arrowPosition.top}px`,
                  left: `${arrowPosition.left}px`,
                  transition: `${currentTarget === 0 ? '' : 'left 2s'}`,
                }}
              >
                <img
                  src="/images/masterclassDescription/arrow.svg"
                  alt="arrow"
                  className={`${arrowPosition.left === 0 ? 'opacity-0' : 'opacity-100'}`}
                />
              </div>
            )}
          </div>

          <div
            className="relative z-0"
            style={{
              width: '60%',
              left: '20%',
              top: '50%',
            }}
          >
            {[...Array(3)].map((_, index) => (
              <div
                key={randomId()}
                className={`absolute border-t ${
                  currentTarget > index + 1
                    ? 'border-green-500 border-solid'
                    : 'border-red-500 border-dashed'
                }`}
                style={{
                  width: '33.33%',
                  left: `${index * 33.33}%`,
                  top: '50%',
                }}
              />
            ))}
          </div>
        </div>
      </div>
      {/* Button to start the animation */}
      {/* <button
          type="button"
          onClick={() => setStartAnimation(true)}
          className="mt-4 px-6 py-2 bg-blue-500 text-white rounded"
        >
          Start Animation
        </button> */}
    </div>
  );
};

export default GlimpsesAnimFromDesktopAndTab;
